export default window.config;